import * as $ from 'jquery';
import { bookingFormCommon } from '../c005-bookingform-common';
import * as numeral from 'numeral';

export class onlineServicesRedirection {
	private bookingformcommon = new bookingFormCommon();

  initializeTheOnlineService(): any {
    let _self = this;
    const urlParams = new URLSearchParams(window.location.search);
    if(urlParams.get('ppid') && urlParams.get('status')) {
      _self.bookingformcommon.preloader();
      let data = {
        ppid: urlParams.get('ppid'),
        status: urlParams.get('status'),
        mopId: urlParams.get('mopId')
      }
      if(urlParams.get('cancel')) {
        $('.checkout-status').html('Transaction Cancelled by User​.');
      } else {
        _self.handleCheckoutResponse(data);
      }
    }
  }
  handleCheckoutResponse(dataRes: any) {
    let _self = this;
    let dataLocal: any = null;
    let vendor: any = null;
    let cardType: any = null;
    let errorMsg: any = null;
    let getdata = function() {
        dataLocal = JSON.parse(localStorage.getItem("online-services-data"));
        if(dataLocal === null) {
            getdata();
        }
    }
    let getCard = function() {
        vendor = localStorage.getItem("cardBin");
        if(vendor === null) {
            getCard();
        }
    }
    let getCardType = function() {
        let list = JSON.parse(localStorage.getItem("cardList"));
        if(list.length > 0) {
            list.map((item: any) => {
                if(item.id === dataRes.mopId) {
                    dataRes.mopId = item.type;
                }
            });
        } else {
            getCardType();
        }
    }
    let getErrorMsg = function() {
        errorMsg = localStorage.getItem("errorMsg");
        if(errorMsg === null) {
            getErrorMsg();
        }
    }
    getdata();
    if(dataRes.mopId === "creditcard") {
        getCard();
    }
    getCardType();
    if(dataRes.status == "error") {
        getErrorMsg();
    }
    let requestData = {
        amount: dataLocal.postRedirectionValue,
        transactionType: 'payment',
        ppid: dataRes.ppid
    }
    if(dataRes.mopId !== "" && dataRes.mopId !== null) {
      requestData['paymentForms'] = dataRes.mopId;
    }
    if(vendor) {
        requestData['vendor'] = vendor;
    }
    _self.bookingformcommon.preloader();
    $.ajax({
        type: 'POST',
        url: "/bin/services/new/paymentGetCheckoutStatus?ppid=" + dataRes.ppid,
        data: requestData,
        success: function(data:any) {
            _self.bookingformcommon.preloaderClose();
            let json: any = null;
            if(typeof data==='string') {
                json = JSON.parse(data);
            } else {
                json = data;
            }
            if(json.errorCode === "OK") {
                $('.checkout-status').html(json.errorMsg);
                let navMilesVal = json.currentBalance;
				$(".miles-value").text(numeral(navMilesVal).format('0,0'));
				document.cookie = "milesCount=" + navMilesVal + ";path=/";
                let strArr = json.errorMsg.split(':');
                window.digitalData = {order: {orderid: strArr[1].trim(), totalamount: dataLocal.postRedirectionValue}};
                const event = new CustomEvent('purchase', { detail: window.digitalData });
                document.dispatchEvent(event);
                console.log(event);
                localStorage.removeItem("cardBin");
                localStorage.removeItem("cardList");
                localStorage.removeItem("online-services-data");
            } else {
                if(errorMsg != null) {
                    $('.checkout-status').html(errorMsg);
                } else {
                    $('.checkout-status').html(json.errorMsg);
                }
                //$('.checkout-status').html(errorMsg);
                localStorage.removeItem("cardBin");
                localStorage.removeItem("cardList");
                localStorage.removeItem("online-services-data");
            }  
        }, error: function(error:any) {
            _self.bookingformcommon.preloaderClose();
            $('.checkout-status').html('Something went wrong!');
            $('.error-description').html(status);
            localStorage.removeItem("cardBin");
            localStorage.removeItem("cardList");
            localStorage.removeItem("online-services-data");
        }
    });
  }
}
let scope : Element = document.querySelector('#online-services-width');
declare const window: any;
if(scope){
    try{
      let OSR = new onlineServicesRedirection();
      OSR.initializeTheOnlineService();
    } catch(e){console.error(e);}
}